import {CommunicationConfigurationModel} from '../../../../../../communication/configuration/api/model/communicationConfiguration.model';
import {WithPermissionModel} from '../../../../../../common/permission/api/entity/withPermission.model';

export class PaymentRequestConfigurationModel extends WithPermissionModel {

    id: number;
    sendReminders: boolean;
    nbDaysBetweenReminders: number;
    communicationConfiguration: CommunicationConfigurationModel;

}
